"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dialog = require("@package/dialog");

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _Component = _interopRequireDefault(require("./Component"));

var mapActionsToProps = function mapActionsToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    openDialog: _dialog.openDialog
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(null, mapActionsToProps)(_Component["default"]);

exports["default"] = _default;